import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { twJoin } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useScrollPosition from 'hooks/useScrollPosition';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import StoresDropdown from './Dropdown';

const StoresDropdownButton = ({ gaEventCategory }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const storesButtonRef = useRef(null);

  const onStoresButtonClick = () => {
    sendEvent({
      action: 'stores_click',
      category: gaEventCategory,
      label: 'Lojas',
    });
    sendEvent({
      action: 'click_shortcut',
      category: gaEventCategory,
      label: 'Lojas',
    });

    setDropdownOpen((prev) => !prev);
  };

  const onCloseDropdown = () => {
    setDropdownOpen(false);
  };

  useScrollPosition(onCloseDropdown, { enabled: isDropdownOpen });

  return (
    <div className={twJoin('relative', isDropdownOpen && 'z-50')}>
      <Button
        ref={storesButtonRef}
        className={twJoin(
          '[&>span]:font-medium [&>svg]:size-3',
          isDropdownOpen && 'relative z-50'
        )}
        data-test-selector="open-stores-dropdown"
        iconRight={
          <Icon
            className="font-bold"
            name={isDropdownOpen ? 'arrow-outline-up' : 'arrow-outline-down'}
            size="size3"
          />
        }
        size="size4"
        type={isDropdownOpen ? 'neutral-stroke' : 'neutral-ghost'}
        onClick={onStoresButtonClick}
      >
        {placeholder('actions.toggleStores')}
      </Button>
      <StoresDropdown
        isOpen={isDropdownOpen}
        openerRef={storesButtonRef}
        onClose={onCloseDropdown}
      />
    </div>
  );
};

StoresDropdownButton.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default StoresDropdownButton;
